import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../PublicLayout';

const RESOURCES = [
  { to: '/how-it-works', title: 'How it works', body: 'Walk through the full challenge flow from start to finish.' },
  { to: '/safety', title: 'Safety & wallet', body: 'Learn how locked funds, settlement, and withdrawals work.' },
  { to: '/faq', title: 'FAQ', body: 'Quick answers to the most common questions.' },
];

export default function SupportPage() {
  return (
    <>
      <PageHero
        eyebrow="We're here to help"
        title="Support"
        subtitle="Find answers fast, or reach out and we'll get back to you."
      />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pb-10">
        <div className="grid sm:grid-cols-3 gap-4">
          {RESOURCES.map((r) => (
            <Link
              key={r.to}
              to={r.to}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:border-emerald-500/30 transition-colors block"
            >
              <h3 className="text-base font-black uppercase tracking-tight text-white mb-2">{r.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{r.body}</p>
            </Link>
          ))}
        </div>
      </section>
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-10 border-t border-white/5 text-center">
        <h2 className="text-2xl font-black tracking-tight text-white mb-3">Still need help?</h2>
        <p className="text-gray-400 text-base font-medium leading-relaxed mb-6">
          Email our team and we'll respond as soon as we can. Live in-app support is coming soon.
        </p>
        <a
          href="mailto:support@lockedin-h2h.com"
          className="inline-flex items-center px-10 py-4 rounded-2xl text-sm font-black uppercase tracking-[0.2em] bg-emerald-500 hover:bg-emerald-400 text-black transition-all"
        >
          Email support
        </a>
      </section>
    </>
  );
}
